import React from "react";

export default function Placeholder() {
  return (
    <svg
      width={110}
      height={110}
      viewBox="0 0 340 343"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M138.722 63.1026C138.733 60.893 140.534 59.1115 142.744 59.124L277.358 59.8818C279.566 59.8942 281.347 61.6941 281.335 63.9026L280.423 238.72C280.412 240.928 278.613 242.71 276.405 242.699L176.111 242.227C175.087 242.222 174.104 241.825 173.364 241.117L139.199 208.422C138.405 207.662 137.959 206.609 137.965 205.51L138.722 63.1026Z"
        fill="#DEDEDE"
      />
      <path
        d="M216.226 115.281L216.195 109.348L215.195 109.353L215.179 106.386C215.177 105.978 215.093 105.591 214.945 105.239L215.867 104.851C215.456 103.875 214.67 103.097 213.689 102.697L213.312 103.623C212.958 103.479 212.571 103.4 212.162 103.402L209.103 103.419L209.097 102.419L202.978 102.454L202.984 103.454L196.865 103.488L196.859 102.488L190.741 102.523L190.746 103.523L184.627 103.557L184.622 102.557L178.503 102.592L178.509 103.592L172.39 103.626L172.384 102.626L166.265 102.661L166.271 103.661L160.152 103.695L160.147 102.695L154.028 102.73L154.033 103.73L147.915 103.764L147.909 102.764L141.79 102.798L141.796 103.798L135.677 103.833L135.671 102.833L129.553 102.867L129.558 103.867L123.439 103.902L123.434 102.902L117.315 102.936L117.321 103.936L111.202 103.971L111.196 102.971L105.077 103.005L105.083 104.005L98.9642 104.04L98.9586 103.04L92.8398 103.074L92.8454 104.074L86.7266 104.108L86.721 103.108L80.6022 103.143L80.6078 104.143L77.5485 104.16C77.14 104.162 76.7534 104.246 76.4019 104.394L76.0138 103.472C75.0385 103.883 74.2609 104.669 73.8608 105.649L74.7865 106.027C74.6423 106.38 74.5633 106.767 74.5654 107.176L74.5806 110.089L73.5806 110.094L73.611 115.922L74.611 115.917L74.6414 121.744L73.6414 121.749L73.6718 127.576L74.6717 127.571L74.7021 133.398L73.7021 133.403L73.7325 139.231L74.7325 139.226L74.7629 145.053L73.7629 145.058L73.7933 150.885L74.7933 150.88L74.8237 156.707L73.8237 156.713L73.8541 162.54L74.8541 162.535L74.8845 168.362L73.8845 168.367L73.9149 174.194L74.9149 174.189L74.9452 180.016L73.9453 180.022L73.9756 185.849L74.9756 185.844L75.006 191.671L74.006 191.676L74.0364 197.503L75.0364 197.498L75.0668 203.325L74.0668 203.331L74.0972 209.158L75.0972 209.153L75.1276 214.98L74.1276 214.985L74.158 220.812L75.158 220.807L75.1883 226.634L74.1884 226.64L74.2187 232.467L75.2187 232.462L75.2491 238.289L74.2491 238.294L74.2795 244.121L75.2795 244.116L75.3099 249.943L74.3099 249.949L74.3403 255.776L75.3403 255.771L75.3707 261.598L74.3707 261.603L74.4011 267.43L75.4011 267.425L75.4314 273.252L74.4315 273.258L74.4619 279.085L75.4618 279.08L75.477 281.993C75.4792 282.402 75.5623 282.788 75.7101 283.14L74.7884 283.527C75.1986 284.503 75.9843 285.281 76.9637 285.681L77.3423 284.756C77.6952 284.9 78.0826 284.979 78.4911 284.978L81.6253 284.963L81.63 285.963L87.8983 285.933L87.8936 284.933L94.1619 284.904L94.1666 285.904L100.435 285.874L100.43 284.874L106.699 284.845L106.703 285.845L112.972 285.815L112.967 284.815L119.235 284.786L119.24 285.786L125.508 285.756L125.504 284.756L131.772 284.727L131.777 285.727L138.045 285.697L138.04 284.697L144.309 284.668L144.313 285.668L150.582 285.638L150.577 284.638L156.845 284.609L156.85 285.609L163.118 285.579L163.114 284.579L169.382 284.55L169.387 285.55L175.655 285.52L175.65 284.52L178.784 284.506C179.552 284.502 180.29 284.204 180.844 283.673L182.98 281.63L183.671 282.352L187.942 278.265L187.25 277.543L191.521 273.456L192.213 274.178L196.483 270.091L195.792 269.369L200.062 265.282L200.754 266.004L205.024 261.917L204.333 261.195L208.604 257.108L209.295 257.83L213.566 253.743L212.874 253.021L215.01 250.977C215.605 250.408 215.94 249.618 215.935 248.794L215.92 245.827L216.92 245.822L216.888 239.888L215.888 239.894L215.857 233.96L216.857 233.955L216.825 228.021L215.825 228.026L215.794 222.093L216.794 222.087L216.762 216.154L215.762 216.159L215.731 210.225L216.731 210.22L216.699 204.286L215.699 204.292L215.668 198.358L216.667 198.353L216.636 192.419L215.636 192.424L215.604 186.491L216.604 186.485L216.573 180.552L215.573 180.557L215.541 174.623L216.541 174.618L216.51 168.684L215.51 168.69L215.478 162.756L216.478 162.751L216.447 156.817L215.447 156.822L215.415 150.889L216.415 150.883L216.384 144.95L215.384 144.955L215.352 139.021L216.352 139.016L216.321 133.082L215.321 133.088L215.289 127.154L216.289 127.149L216.258 121.215L215.258 121.22L215.226 115.287L216.226 115.281Z"
        stroke="#E4E4E4"
        strokeWidth={2}
        strokeDasharray="6 6"
      />
      <path
        d="M244.663 262.254L102.05 261.451L103.004 78.6375L208.89 79.1358L245.45 114.124L244.663 262.254Z"
        fill="#EDEDED"
      />
      <path
        d="M206.958 78.4482L244.212 112.696L207.481 113.255L206.958 78.4482Z"
        fill="#B1B1B1"
      />
      <path
        d="M94.0082 45.3994L92.9943 43.5058C90.6854 39.6091 90.2281 34.3988 92.6332 28.0007C94.7953 22.2574 95.6405 18.4106 94.1272 14.9307C92.3832 11.0398 88.4916 9.63216 82.9567 11.8677C79.8334 13.2217 76.7458 15.5532 75.1402 17.9798L70.9009 14.0813C73.0079 11.0469 77.4253 7.73395 82.0862 5.74711C92.1173 1.51417 99.0217 5.00456 101.638 10.8409C103.932 16.0166 102.271 21.152 99.9393 27.3111C97.8025 32.9036 97.8973 36.9021 99.9021 40.6268L100.868 42.6088L94.0082 45.3994ZM96.7699 56.9137C95.5076 54.1203 96.8369 51.1579 99.9121 49.8923C102.987 48.6266 105.941 49.6694 107.156 52.5511C108.301 55.2455 107.256 58.1042 103.991 59.51C100.986 60.7498 97.9866 59.5822 96.7699 56.9137Z"
        fill="#B1B1B1"
      />
      <path
        d="M140.408 151.731C145.082 151.731 148.871 147.945 148.871 143.273C148.871 138.602 145.082 134.815 140.408 134.815C135.735 134.815 131.946 138.602 131.946 143.273C131.946 147.945 135.735 151.731 140.408 151.731Z"
        fill="#424242"
      />
      <path
        d="M207.308 151.731C211.982 151.731 215.771 147.945 215.771 143.273C215.771 138.602 211.982 134.815 207.308 134.815C202.634 134.815 198.846 138.602 198.846 143.273C198.846 147.945 202.634 151.731 207.308 151.731Z"
        fill="#424242"
      />
      <path
        d="M185.985 153.13L185.519 152.265C185.452 152.198 181.121 144.14 172.325 144.14C164.329 144.14 162.33 151.732 162.264 152.065L161.997 153.064L160.065 152.597L160.265 151.599C160.265 151.532 162.664 142.142 172.259 142.142C182.254 142.142 187.051 150.999 187.251 151.332L187.718 152.198L185.985 153.13Z"
        fill="#424242"
      />
      <line
        x1="118.167"
        y1="178.149"
        x2="224.891"
        y2="178.149"
        stroke="#B1B1B1"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <line
        x1="118.167"
        y1="192.928"
        x2="224.891"
        y2="192.928"
        stroke="#B1B1B1"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <line
        x1="118.167"
        y1="207.706"
        x2="224.891"
        y2="207.706"
        stroke="#B1B1B1"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <line
        x1="118.167"
        y1="220.372"
        x2="224.891"
        y2="220.372"
        stroke="#B1B1B1"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <line
        x1="118.167"
        y1="236.206"
        x2="224.891"
        y2="236.206"
        stroke="#B1B1B1"
        strokeWidth={2}
        strokeLinecap="round"
      />
      <g clipPath="url(#clip0_427_3089)">
        <path
          d="M129.793 101.039L137.63 93.2014C138.496 92.3355 138.496 90.9316 137.63 90.067L136.585 89.0222C135.719 88.156 134.315 88.156 133.45 89.0222L125.613 96.8592L117.776 89.0205C116.91 88.1546 115.506 88.1546 114.642 89.0205L113.595 90.0654C112.729 90.9316 112.729 92.3355 113.595 93.2L121.434 101.039L113.597 108.876C112.731 109.742 112.731 111.146 113.597 112.01L114.642 113.055C115.508 113.921 116.912 113.921 117.776 113.055L125.613 105.218L133.45 113.055C134.317 113.921 135.72 113.921 136.585 113.055L137.63 112.01C138.496 111.144 138.496 109.74 137.63 108.876L129.793 101.039Z"
          fill="#B1B1B1"
        />
      </g>
      <path
        d="M19.1113 248.289C19.1113 253.399 15.19 257.373 10.5556 257.373C5.92133 257.373 2 253.399 2 248.289C2 243.18 5.92133 239.206 10.5556 239.206C15.19 239.206 19.1113 243.18 19.1113 248.289Z"
        stroke="#E4E4E4"
        strokeWidth={4}
      />
      <line
        x1="28.5449"
        y1="180.651"
        x2="28.5449"
        y2="204.811"
        stroke="#E4E4E4"
        strokeWidth={3}
        strokeLinecap="round"
      />
      <line
        x1="14.1665"
        y1="192.029"
        x2="40.7223"
        y2="192.029"
        stroke="#E4E4E4"
        strokeWidth={3}
        strokeLinecap="round"
      />
      <path
        d="M320.781 184.956C320.781 190.065 324.702 194.039 329.336 194.039C333.971 194.039 337.892 190.065 337.892 184.956C337.892 179.846 333.971 175.872 329.336 175.872C324.702 175.872 320.781 179.846 320.781 184.956Z"
        stroke="#E4E4E4"
        strokeWidth={4}
      />
      <line
        x1="1.5"
        y1="-1.5"
        x2="25.6594"
        y2="-1.5"
        transform="matrix(4.37114e-08 1 1 -4.37114e-08 312.847 115.816)"
        stroke="#E4E4E4"
        strokeWidth={3}
        strokeLinecap="round"
      />
      <line
        x1="1.5"
        y1="-1.5"
        x2="28.0558"
        y2="-1.5"
        transform="matrix(-1 0 0 1 327.226 130.194)"
        stroke="#E4E4E4"
        strokeWidth={3}
        strokeLinecap="round"
      />
      <path
        d="M204.891 297.373C204.891 301.056 202.122 303.818 198.974 303.818C195.826 303.818 193.057 301.056 193.057 297.373C193.057 293.69 195.826 290.929 198.974 290.929C202.122 290.929 204.891 293.69 204.891 297.373Z"
        stroke="#E4E4E4"
        strokeWidth={4}
      />
      <line
        x1="236.021"
        y1="277.763"
        x2="236.021"
        y2="299.041"
        stroke="#E4E4E4"
        strokeWidth={3}
        strokeLinecap="round"
      />
      <line
        x1="223.169"
        y1="287.615"
        x2="246.589"
        y2="287.615"
        stroke="#E4E4E4"
        strokeWidth={3}
        strokeLinecap="round"
      />
      <path
        d="M270.82 264.429C285.769 250.776 286.82 227.59 273.167 212.642C259.514 197.693 236.328 196.643 221.38 210.295C206.431 223.948 205.381 247.134 219.033 262.082C232.686 277.031 255.872 278.082 270.82 264.429Z"
        fill="#FF989C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M279.584 277.08L268.989 284.012C267.606 284.917 267.219 286.771 268.124 288.154L287.792 318.213C287.792 318.213 294.037 323.009 299.153 318.42C305.312 312.897 303.394 308.004 303.394 308.004L283.726 277.945C282.821 276.562 280.967 276.175 279.584 277.08Z"
        fill="#FF989C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M262.814 270.949L270.123 266.167L277.923 278.087L270.614 282.87L262.814 270.949Z"
        fill="#F0F4F7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M229.731 212.687C215.959 221.699 212.098 240.17 221.11 253.942C230.122 267.716 248.594 271.574 262.366 262.563C276.138 253.551 279.998 235.081 270.986 221.307C261.974 207.535 243.504 203.675 229.731 212.687Z"
        fill="#F0F4F7"
      />
      <g opacity="0.2">
        <path
          d="M282.169 276.078L276.374 279.179L294.25 306.499C296.568 310.041 298.498 312.992 295.249 315.909C291.999 318.825 287.018 316.132 288.196 317.047C289.375 317.961 292.767 321.456 297.157 320.597C298.859 320.263 301.492 318.099 302.691 315.535C304.032 312.666 303.394 309.147 303.394 309.147C303.169 306.925 302.058 306.226 299.88 302.897L282.169 276.078Z"
          fill="black"
        />
        <path
          d="M248.564 200.814C248.564 200.814 267.828 212.207 270.535 237.876C273.243 263.545 244.763 274.433 244.763 274.433C244.763 274.433 253.08 276.596 267.507 267.597C281.935 258.597 286.65 239.528 278.639 220.279C270.626 201.029 248.564 200.814 248.564 200.814Z"
          fill="black"
        />
        <path
          d="M266.588 268.479L270.122 266.166L277.922 278.087L274.388 280.399L266.588 268.479Z"
          fill="black"
        />
      </g>
      <path
        d="M271.972 220.661C262.637 206.393 243.433 202.38 229.163 211.717C214.895 221.053 210.884 240.256 220.22 254.524C229.556 268.792 248.758 272.806 263.026 263.47C277.296 254.133 281.308 234.929 271.972 220.661ZM222.097 253.296C213.438 240.061 217.159 222.252 230.391 213.594C243.625 204.935 261.436 208.655 270.095 221.889C278.755 235.123 275.032 252.933 261.798 261.593C248.565 270.251 230.756 266.53 222.097 253.296Z"
        fill="#9B9B9B"
      />
      <path
        d="M277.877 216.798C266.409 199.273 242.824 194.344 225.299 205.812C207.774 217.279 202.845 240.864 214.312 258.39C224.782 274.39 245.341 279.847 262.178 271.956L269.13 282.58L268.107 283.25C266.358 284.394 265.866 286.75 267.01 288.499L285.774 317.176C288.859 321.89 295.204 323.217 299.918 320.133L300.177 319.964C304.891 316.879 306.216 310.533 303.131 305.819L284.367 277.142C283.223 275.393 280.866 274.901 279.118 276.045L278.095 276.714L271.143 266.09C285.114 253.82 288.345 232.797 277.877 216.798ZM216.189 257.161C205.4 240.672 210.037 218.478 226.527 207.689C243.016 196.899 265.21 201.537 276 218.026C286.79 234.517 282.153 256.711 265.663 267.501C249.174 278.29 226.98 273.653 216.189 257.161ZM282.49 278.37L301.254 307.047C303.662 310.728 302.628 315.679 298.949 318.087L298.69 318.256C295.011 320.663 290.06 319.628 287.651 315.947L268.887 287.27C268.42 286.556 268.62 285.594 269.335 285.127L280.346 277.922C281.061 277.454 282.022 277.655 282.49 278.37ZM276.218 277.942L271.007 281.352L264.2 270.95C265.108 270.457 266.012 269.953 266.891 269.378C267.771 268.802 268.596 268.175 269.412 267.54L276.218 277.942Z"
        fill="#9B9B9B"
      />
      <defs>
        <clipPath id="clip0_427_3089">
          <rect
            width="25.3336"
            height="25.3336"
            fill="white"
            transform="translate(112.946 88.3711)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
